// @ts-nocheck
export const localeCodes =  [
  "zh",
  "en",
  "ja",
  "ko"
]
export const localeLoaders = {
  zh: [
    {
      key: "locale_zh_46json_eb6b6151",
      load: () => import("#nuxt-i18n/eb6b6151" /* webpackChunkName: "locale_zh_46json_eb6b6151" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_fd6e2db5",
      load: () => import("#nuxt-i18n/fd6e2db5" /* webpackChunkName: "locale_ja_46json_fd6e2db5" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_99c519a6",
      load: () => import("#nuxt-i18n/99c519a6" /* webpackChunkName: "locale_ko_46json_99c519a6" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "zh",
    value: "中文",
    iso: "zh-TW",
    language: "zh-TW",
    _hreflang: "zh-TW",
    _sitemap: "zh-TW"
  },
  {
    code: "en",
    value: "English",
    iso: "en-US",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US"
  },
  {
    code: "ja",
    value: "日本語",
    iso: "ja",
    language: "ja",
    _hreflang: "ja",
    _sitemap: "ja"
  },
  {
    code: "ko",
    value: "한국어",
    iso: "ko",
    language: "ko",
    _hreflang: "ko",
    _sitemap: "ko"
  }
]
/** client **/

/** client-end **/